import React, { useState, useRef, Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useMutation } from 'components/graphql'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import FieldLists from './lists-submodules/FieldLists'
import { ListQuery, updateQuery } from 'components/graphql'
import { Form, Text } from 'components/forms'
import Button from 'components/Button'
import { ContentBlock } from 'components/ContentBlock'
import { createProductList, updateProductList } from '../../gql/mutation'
import { listProductLists } from '../../gql/query'

const Lists = ({ data = {}, formData, mutations: { updateItem }, itemId }) => {
	const inputRef = useRef()
	const [t] = useTranslation()
	const [editingList, setEditingList] = useState(null)
	const mutation = editingList && editingList.id ? updateProductList : createProductList
	const [mutateList] = useMutation(mutation)

	const focusInput = () => {
		if(inputRef.current) {
			inputRef.current.focus()
		}
	}
	const isUpdatingList = editingList && editingList.id // Otherwise creating new one
	const key = Array.isArray(data.lists) ? data.lists.reduce((sum, { mod_ver }) => sum + Number(mod_ver), 0) : 0

	const handleFormChange = ({ lists = [], ...restVals }) => {
		// Don't send listItems which haven't been updated
		const mutationVals = {
			...restVals,
			lists: lists.filter(({ id, ...rest }) => (!id || (id && !Object.keys(rest).length)))
		}
		updateItem(mutationVals)
	}

	return(
		<ContentBlock>
			<ListQuery query={listProductLists}>
				{({ data: listsData }) => {
					return(
						<Form key={key} initialValues={formData} onSubmit={handleFormChange} smartSubmit>
							<Fragment>
								<Row>
									<Col xs={5}>
										<FieldLists
											field='lists'
											data={listsData}
											onRowClick={(state, { original }) => {
												setEditingList(original)
												focusInput()
											}}
											onDelItem={delId => {
												// if(editingList.id === delId) {
												//  setEditingList(null)
												// }
											}}
											onAdd={() => setEditingList({})}
											productId={itemId} />
									</Col>
									<Col xs={5}>
										{editingList &&
											<Fragment>
												<Text
													noForm
													value={editingList.name || ''}
													onChange={e => setEditingList({ ...editingList, name: e.target.value })}
													label={t('product_section.strings.add_new_list')}
													placeholder='Name Liste'
													ref={inputRef}
												/>
												<Button
													status={editingList.name ? 'primary' : 'inactive'}
													text={t('product_section.sub_sections.list') + ' ' + t(`product_section.strings.${isUpdatingList ? 'update' : 'add'}`)}
													size='small'
													onClick={e => {
														const variables = { fields: { name: editingList.name } }
														if(isUpdatingList) {
															variables.id = editingList.id
														}
														const mutationDataName = `${isUpdatingList ? 'update' : 'create'}ProductList`
														// mutateList({
														//  variables: variables,
														//  update: (cache, { data: { [mutationDataName]: dataFields } }) => {
														//      const { [queryName]: lists } = cache.readQuery({ query: listProductLists })
														//      const newLists = isUpdatingList ?
														//          lists.map(item => dataFields.id === item.id ? dataFields : item)
														//          : [...lists, dataFields]
														//      cache.writeQuery({
														//          query: listProductLists,
														//          data: { [queryName]: newLists }
														//      })
														//  },
														//  optimisticResponse: {
														//      __typename: 'Mutation',
														//      [mutationDataName]: {
														//          __typename: 'ProductList',
														//          ...editingList,
														//          id: editingList.id || Math.round(Math.random() * -10000)
														//      }
														//  }
														// })
														mutateList({
															variables: variables,
															update: updateQuery({ query: listProductLists }, (draft, { mutationResult = {}, readQuery, queryField }) => {
																const mutatedId = get(mutationResult, 'id', '')
																const newLists = isUpdatingList
																	? readQuery.map((item = {}) => mutatedId.toString() === item.id.toString() ? mutationResult : item)
																	: [...readQuery, mutationResult]
																draft[queryField] = newLists
															}),
															optimisticResponse: {
																cashAssist: {
																	[mutationDataName]: {
																		__typename: 'ProductList',
																		...editingList,
																		id: editingList.id || Math.round(Math.random() * -10000)
																	},
																	__typename: 'CA_Mutation'
																}
															}
														})
														setEditingList(null)
													}} />
												<Button status='cancelation' shrink text={t('common.buttons.cancel')} onClick={e => setEditingList(null)} />
											</Fragment>
										}
									</Col>
								</Row>
							</Fragment>
						</Form>
					)
				}}
			</ListQuery>
		</ContentBlock>
	)
}

export default Lists
